import { Injectable, PLATFORM_ID, Inject, OnDestroy } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { Subject, throwError } from "rxjs";
import { UtilsService } from "./utils.service";
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { catchError } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { Subscription } from 'rxjs/internal/Subscription';
import { CartService } from "./cart.service";
@Injectable({ providedIn: "root" })
export class AnalyticsService implements OnDestroy {
  private previousUrl!: string;
  private currentUrl: string;
  private subject = new Subject<any>();
  sub:Subscription=new Subscription()
  constructor(
    private _router: Router, private http: HttpClient, private utils: UtilsService, private service: CartService,
    @Inject(PLATFORM_ID) private platformId: Object,

  ) {
    this.currentUrl = this._router.url;
   this.sub.add( _router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      };
    }));

    // this.sub.add(this.subject.subscribe(data => {
    //   if (isPlatformBrowser(this.platform)) {
    //     (<any>window).webengage.track(data.eventName, data.eventData);
    //   }
    // }));
  }

  trackData(data: any) {
    this.subject.next(data);
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }

  triggerSupportContactEvent(contact: any, section: string) {
    const data = {
      eventName: 'supportContactClicked',
      eventData: {
        'Option clicked': (contact).toString(),
        'Section': section
      }
    };
    this.trackData(data);
  }

  triggerplpViewed(sourceName: any, isEshop: boolean) {
    const data = {
      eventName: isEshop ? "E-Shop PLP Viewed" : 'Brand PLP Viewed',
      eventData: {
        'Pin Code': Number(this.utils.getUserPicode()),
        'Source': sourceName
      }
    };
    this.trackData(data);
  }

  triggerCartViewed() {
    let cartInfo$: any = [];
    this.sub.add(this.service.cartData$.subscribe((data) => {
      if (data)
        cartInfo$ = data;
    }))
    if (cartInfo$ && cartInfo$.length) {
      const totalQuantity = cartInfo$.reduce(
        (accumulator: any, currentValue: any) => accumulator + (currentValue.quantity),
        0
      )
      const gtmData = {
        eventName: "Cart Viewed",
        eventData: {
          'Pincode': Number(this.utils.getUserPicode()),
          'Total Price': parseFloat((Math.round((this.getOrderTotal()) * 100) / 100).toFixed(2)),
          'Total Items': cartInfo$.length,
          'Total Quantity': totalQuantity,
          'line items': cartInfo$.map((data: any) => {
            return {
              'Product Name': data.productName,
              'Product Price': data.productMRP,
              'Product Image': data.productImageFileName,
              'total quantity': data.quantity,
              'total price': parseFloat((Math.round((this.getItemTotal(data)) * 100) / 100).toFixed(2)),
              'price before tax': parseFloat((Math.round((data.basePrice) * 100) / 100).toFixed(2)),
              'tax': parseFloat((Math.round(((data.basePrice / 100) * data.taxPercent) * 100) / 100).toFixed(2)),
            }
          })
        }
      };
      this.trackData(gtmData);
    }
  }

  triggerCheckoutStartEvent() {
    if (isPlatformBrowser(this.platformId)) {
    let couponData: any;
    let totalTaxes = 0;
    const productInfo = JSON.parse(this.utils.getProductInfo());
    let cartInfo$: any = [];
    let cart: any = (localStorage.getItem('cart'))
    cartInfo$ = JSON.parse(cart);
    if (cartInfo$ && cartInfo$.length) {
      cartInfo$.forEach((element: any) => {
        element.basePrice = (((element.sellingPrice - element.discount) * 100) / (element.taxPercent + 100)) * element.quantity
        element.taxAmount = (element.basePrice / 100) * element.taxPercent
        totalTaxes = totalTaxes + element.taxAmount
      });

      let totalQuantity = 0;
      totalQuantity = cartInfo$.reduce(
        (accumulator: any, currentValue: any) => accumulator + currentValue.quantity,
        0
      );
      this.sub.add(this.utils.discountCouponData.subscribe((data) => {
        couponData = data;
      }))
      let couponDiscount = (couponData && Object.keys(couponData).length !== 0) ? couponData['totalDiscount'] : 0
      const gtmData = {
        eventName: "Checkout Started",
        eventData: {
          'Pincode': Number(this.utils.getUserPicode()),
          'Total Price': this.getOrderTotal() - couponDiscount,
          'Total Items': cartInfo$.length,
          'Category Name': (productInfo && productInfo.category) ? productInfo.category : '',
          'Sub-category name': (productInfo && productInfo.brandSubCategoriesMenus.subCategory) ? productInfo.brandSubCategoriesMenus.subCategory : '',
          'Series Name': productInfo && productInfo.seriesName ? productInfo.seriesName : '',
          'Tax': parseFloat((Math.round(totalTaxes * 100) / 100).toFixed(2)),
          'Product Name': this.utils.getCommaSeparatedValue(cartInfo$, 'productName'),
          // 'Discount': totalDiscount,
          'line items': cartInfo$.map((data: any) => {
            return {
              'Product Name': data.productName,
              'Product Price': data.productMRP,
              'Product Image': data.productImageFileName,
              'total quantity': data.quantity,
              'total price': parseFloat((Math.round((this.getItemTotal(data)) * 100) / 100).toFixed(2)),
              'price before tax': parseFloat((Math.round((data.basePrice) * 100) / 100).toFixed(2)),
              'tax': parseFloat((Math.round(((data.basePrice / 100) * data.taxPercent) * 100) / 100).toFixed(2)),
            }
          }),
          'Total Quantity': totalQuantity || 0,
          'Coupon Applied': couponData && Object.keys(couponData).length !== 0 ? true : false,
          'Coupon Name': couponData && Object.keys(couponData).length !== 0 ? couponData['couponCode'] : '',
          'Coupon Discount': couponData && Object.keys(couponData).length !== 0 ? couponData['totalDiscount'] : 0
        }
      };
      this.trackData(gtmData);
    }
  }
  }
  triggerCheckoutAddressEvent() {
    if (isPlatformBrowser(this.platformId)) {
    let addressList;
    let couponData;
    let totalTaxes = 0;
    let priceBeforeTax = 0;
    let shippingAddress: string;
    let billingAddress: string;
    let shippingInfo
    let billingInfo
    if (this.utils.getToken()) {
      addressList = this.utils.getAddresses() ? this.utils.getAddresses() : [];
      addressList.sort(function (x:any, y:any) {
        return (x === y) ? 0 : x ? -1 : 1;
      });
      shippingInfo = addressList.filter((data: any) => {
        return !data.isBillingAddress
      })[0];
      billingInfo = addressList.filter((data: any) => {
        return data.isBillingAddress
      })[0];
    }
    else {
      addressList = this.utils.addressForGuestUser ? this.utils.addressForGuestUser : [];
      shippingInfo = addressList.filter((data: any) => {
        return data.isShipping
      })[0];
      billingInfo = addressList.filter((data: any) => {
        return !data.isShipping
      })[0];
    }
    billingAddress = `${billingInfo.houseNo} ${billingInfo.streetAddress} ${billingInfo.landmark} ${billingInfo.city} ${billingInfo.state}-${billingInfo.pinCode} ${billingInfo.country} `;
    shippingAddress = `${shippingInfo.houseNo} ${shippingInfo.streetAddress} ${shippingInfo.landmark} ${shippingInfo.city} ${shippingInfo.state}-${shippingInfo.pinCode} ${shippingInfo.country} `;
    const productInfo = JSON.parse(this.utils.getProductInfo());
    let cartInfo$: any = [];
    let cart: any = (localStorage.getItem('cart'))
    cartInfo$ = JSON.parse(cart);

    cartInfo$.forEach((element: any) => {
      element.basePrice = (((element.sellingPrice - element.discount) * 100) / (element.taxPercent + 100)) * element.quantity
      element.taxAmount = (element.basePrice / 100) * element.taxPercent
      totalTaxes = totalTaxes + element.taxAmount
    });
    this.sub.add( this.utils.discountCouponData.subscribe((data) => {
      couponData = data;
    }))
    let totalQuantity = 0;
    totalQuantity = cartInfo$.reduce(
      (accumulator: any, currentValue: any) => accumulator + currentValue.quantity,
      0
    );
    priceBeforeTax = cartInfo$.reduce(
      (accumulator: any, currentValue: any) => accumulator + currentValue.basePrice,
      0
    );
    let couponDiscount = (couponData && Object.keys(couponData).length !== 0) ? couponData['totalDiscount'] : 0
    const gtmData = {
      eventName: "Checkout_Address_Details",
      eventData: {
        'Pincode': Number(this.utils.getUserPicode()),
        'Total Price': this.getOrderTotal() - couponDiscount,
        'Total Items': cartInfo$.length,
        'Category Name': (productInfo && productInfo.category) ? productInfo.category : '',
        'Sub-category name': (productInfo && productInfo.brandSubCategoriesMenus.subCategory) ? productInfo.brandSubCategoriesMenus.subCategory : '',
        'Series Name': productInfo && productInfo.seriesName ? productInfo.seriesName : '',
        'Tax': parseFloat((Math.round(totalTaxes * 100) / 100).toFixed(2)),
        'Shipping Address': shippingAddress,
        'Billing Address': billingAddress,
        'Product Name': this.utils.getCommaSeparatedValue(cartInfo$, 'productName'),
        'Product Price_before': parseFloat((Math.round(priceBeforeTax * 100) / 100).toFixed(2)),
        'line items': cartInfo$.map((data: any) => {
          return {
            'Product Name': data.productName,
            'Product Price': data.productMRP,
            'Product Image': data.productImageFileName,
            'total quantity': data.quantity,
            'total price': parseFloat((Math.round((this.getItemTotal(data)) * 100) / 100).toFixed(2)),
            'price before tax': parseFloat((Math.round((data.basePrice) * 100) / 100).toFixed(2)),
            'tax': parseFloat((Math.round(((data.basePrice / 100) * data.taxPercent) * 100) / 100).toFixed(2)),
          }
        }),
        'Total Quantity': totalQuantity || 0,
        'Coupon Applied': couponData && Object.keys(couponData).length !== 0 ? true : false,
        'Coupon Name': couponData && Object.keys(couponData).length !== 0 ? couponData['couponCode'] : '',
        'Coupon Discount': couponData && Object.keys(couponData).length !== 0 ? couponData['totalDiscount'] : 0
      }
    };
    this.trackData(gtmData);
  }
  }

  getOrderDetail(orderNo: any) {
      let url = this.utils.apiUrl + 'Order/GetDetailOfPaidOrderForWebEngage?orderNumber=' + orderNo;
      if (this.utils.getToken()) {
        return this.http.get(url).pipe(catchError(this.utils.processError.bind(this)))
      }
      else {
        return this.http.get(url, { headers: this.utils.addTempTokenHeader })
          .pipe(catchError(this.utils.processError.bind(this)))
      }

  }

  getOrderTotal() {
    if (isPlatformBrowser(this.platformId)) {
    let cartDetail: any = [];
    let totalPrice = 0;
    let totalTaxes = 0;
    let orderTotal = 0;
    let isBuyNow: any = localStorage.getItem('buyNow');
    if (!isBuyNow) {
      this.sub.add(  this.service.cartData$.subscribe(
        (data: any) => {
          if (data)
            cartDetail = data
        }));
    }
    else {
      this.sub.add( this.service.buyNowData$.subscribe(
        (data: any) => {
          cartDetail = data ? data : []
        }))
    }
    if (cartDetail && cartDetail.length) {
      cartDetail.forEach((element: any) => {
        element.basePrice = (((element.sellingPrice - element.discount) * 100) / (element.taxPercent + 100)) * element.quantity
        element.taxAmount = (element.basePrice / 100) * element.taxPercent
        totalPrice = totalPrice + element.basePrice
        totalTaxes = totalTaxes + element.taxAmount
      });
    }
    orderTotal = parseFloat((Math.round((totalPrice + totalTaxes) * 100) / 100).toFixed(2))
    return orderTotal;
  }else{
    return 0
  }
}

  getItemTotal(item: any) {
    let totalPrice = 0;
    let totalTaxes = 0;
    let orderTotal = 0;

    item['basePrice'] = (((item.sellingPrice - item.discount) * 100) / (item.taxPercent + 100)) * item.quantity
    item.taxAmount = (item.basePrice / 100) * item.taxPercent
    totalPrice = totalPrice + item.basePrice
    totalTaxes = totalTaxes + item.taxAmount
    orderTotal = parseFloat((Math.round((totalPrice + totalTaxes) * 100) / 100).toFixed(2))
    return orderTotal;
  }

  triggerLoadInitiated(sourceName: string) {
    const data = {
      eventName: "Load Calculator Initiated",
      eventData: {
        Source: sourceName
      }
    };
    this.trackData(data);
  }

  trackContactUs()
  {
    if ((window as any).fbq) {
    (window as any).fbq('track', 'Contact');
    } else {
    }
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
